import { EIntegrationStatus, TCustomField } from '../custom-fields.model';

export const isCustomFieldVisibilityEditable = (field: TCustomField): boolean =>
  field.volyIntegrationActive !== EIntegrationStatus.ON;
